/* Lightweight slider replacing Swiper for benefits/product-benefits/related-articles/story sections.
   Scoped per [data-slider] root so multiple instances on one page don't collide. */
(function () {
  'use strict';

  function setupSlider(root) {
    var track = root.querySelector('[data-slider-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-slider-slide]');
    if (!slides.length) return;

    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    var counter = root.querySelector('[data-slider-counter]');
    var total = slides.length;
    var current = 0;

    function update() {
      if (counter) counter.textContent = (current + 1) + ' OF ' + total;
    }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx > total - 1) idx = total - 1;
      slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (entries) {
        var bestRatio = 0;
        var bestIdx = current;
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].intersectionRatio > bestRatio) {
            bestRatio = entries[i].intersectionRatio;
            var idx = Array.prototype.indexOf.call(slides, entries[i].target);
            if (idx >= 0) bestIdx = idx;
          }
        }
        if (bestRatio > 0 && bestIdx !== current) {
          current = bestIdx;
          update();
        }
      }, { root: track, threshold: [0.6] });
      for (var s = 0; s < slides.length; s++) io.observe(slides[s]);
    }

    update();
  }

  function init() {
    var roots = document.querySelectorAll('[data-slider]');
    for (var i = 0; i < roots.length; i++) setupSlider(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
